import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Compart, ShoeSize, ComponentGrouser, Make, ComponentSetup, SystemModelTemplate, ResultMessage } from '../../../../entities';
import { AppService } from '../../../../app.service';
import { SetupUndercarriageService } from '../../../setup-undercarriage';
import { Observable } from 'rxjs/Observable';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ActionService } from '../../action.service.service';
import { ReplaceMultipleComponentsOnSystemViewModel, ReplacingComponentsOnSystemViewModel, ComponentReplacementWillBeEffectActionsWarningViewModel, ComponentWarningViewModel } from '../../action-models';
import { TranslateService } from '../../../../translate';
import { SelectionModel } from '@angular/cdk/collections';
import { EquipmentDetails } from '../../../../modules/manage-equipment/models/manage-equipment.model';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import moment from 'moment';
import { debounceTime } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'create-multiple-system-components',
  templateUrl: './create-multiple-system-components.component.html',
  styleUrls: ['./create-multiple-system-components.component.scss']
})
export class CreateMultipleSystemComponentsComponent implements OnInit, OnChanges {
 
  // _displayedColumns = ['delete', 'Component', 'Type', 'Position', 'Brand', 'BudgetLife', 'HoursAtInstall', 'InstallCost', 'Size', 'Grouser'];

  _displayedColumns = ['delete', 'Component', 'Type', 'Position', 'Brand', 'BudgetLife', 'HoursAtInstall', 'PartCost', 'LabourCost', 'MiscCost', 'Size', 'Grouser', 'excluded'];
@Input()
systemSide: number;
@Input()
equipmentId: number;

@Input()
selectedEquipment: EquipmentDetails;



public today = new Date();




  _currentAvailableTypes: Compart[] = [];
  _availableShoeSizes: ShoeSize[] = [];
  _availableGrousers: ComponentGrouser[] = [{ Id: 0, Title: 'Unknown' }, { Id: 1, Title: 'Single Grouser' }, { Id: 2, Title: 'Double Grouser' }, { Id: 3, Title: 'Triple Grouser' }];
  _availableComponentMakes: Make[] = [];


  replacingSystemDataSource = new MatTableDataSource();



  IsAChainSystemReplacement = false;


  userLanguage: 'English';



  actionForm: FormGroup;
DateControl: FormControl;
SMUControl: FormControl;

  actionDate: Date;
  actionAtEquipmentSMU: number;

  private _chainSystemId: number;
  private _frameSystemId: number;


  backEndVaildation: ComponentReplacementWillBeEffectActionsWarningViewModel;




  private _systemTemplate: SystemModelTemplate[] = [];


  selection = new SelectionModel<ReplacingComponentsOnSystemViewModel>(true, []);
  reStructuredData: (ReplacingComponentsOnSystemViewModel | GroupBy)[] = [];





  constructor(private _appService: AppService,
    private _setupService: SetupUndercarriageService,
    private _loadingService: LoadingService,
    private _actionService: ActionService,
    private _translate: TranslateService,
    public snackBar: MatSnackBar,
    ) { }

  ngOnInit() {
    const shoeList = this._setupService.getShoeSizeList();
    const componentMakeList =  this._setupService.getComponentMakeList();
    Observable.forkJoin(shoeList, componentMakeList).subscribe(r => {

      this._availableShoeSizes = r[0];
      this._availableComponentMakes = r[1];
    });
    this.SMUControl = new FormControl(this.actionAtEquipmentSMU, [ Validators.required]);
    this.DateControl = new FormControl( moment( new Date(this.actionDate) ), [ Validators.required]);


    this.actionForm = new FormGroup({
      SMUControl : this.SMUControl,
      DateControl : this.DateControl,
    });

    Object.keys(this.actionForm.controls).forEach(key => {
      const control  = this.actionForm.get(key);
      if ( key !== 'DateControl' && key !== 'SMUControl' )return;
      control.valueChanges.pipe(debounceTime(1000))
      .map(
        a => {

        })
      .subscribe(
        () => {
          this.getVaildateNewSystem();
        }
      );
    });
  }




  ngOnChanges(changes: SimpleChanges) {
    if (this.systemSide !== undefined && this.equipmentId !== undefined) {
      this._loadingService.startLoading();
      this._actionService.GetReplacingMultipleComponentsOnSystemViews(this.equipmentId, this.systemSide).subscribe(a => {
        this.GetExtraMakeIfItIsNotInOEM(a[0]);
        const compartsQuery =  this.getAvailableComparts(a[0].ModelId);
        const templateQuery =   this.getSystemTemplate(a[0].ModelId);
        this.reOrganizeData(a);
        this.replacingSystemDataSource.data = this.reStructuredData;
        Observable.forkJoin(compartsQuery, templateQuery).subscribe(r => {

          this._currentAvailableTypes = r[0];
          this._systemTemplate = r[1];
          this._loadingService.finishedLoading();
        });
      });
    }
  }


  reOrganizeData(a: ReplaceMultipleComponentsOnSystemViewModel[]) {
    this.reStructuredData = [];
    for (let r = 0; r < a.length; r ++) {
      this.reStructuredData.push({systemType: a[r].SystemType, isGroupBy : true});

      if (a[r].SystemType === 1) { this._chainSystemId = a[r].SystemId; }
      if (a[r].SystemType === 2) { this._frameSystemId = a[r].SystemId; }

      for (let i = 0; i < a[r].Components.length; i++) {
       this.reStructuredData.push(a[r].Components[i]);
      }
    }

  }


  private GetExtraMakeIfItIsNotInOEM(systems: ReplaceMultipleComponentsOnSystemViewModel) {
    if ( this._availableComponentMakes.filter( m => m.Title === systems.MakeDesc ).length === 0) {
      this._actionService.getExtraMakeOfThisEquipment(this.equipmentId).subscribe(m =>  {
        this._availableComponentMakes.unshift(m);
      });
    }
  }


  brandSelected(event) {

  }


  private getAllComponentsIds(): number[] {
    const result = [];
    for ( let i = 0; i < this.reStructuredData.length; i++) {
      if ((<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).GeneralEqUnitId !== undefined
      ) {
        result.push((<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).GeneralEqUnitId);
      }
    }
    return result;
  }


  removeElement( removing: ReplacingComponentsOnSystemViewModel): void {
    for ( let i = 0; i < this.reStructuredData.length; i++) {
      if (
        (<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).Position !== undefined &&
        (<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).CompartTypeId !== undefined &&
        (<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).CompartId !== undefined &&
        (<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).CompartTypeId === removing.CompartTypeId &&
        (<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).CompartId === removing.CompartId &&
        (<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).Position === removing.Position
      ) {
        // this.reStructuredData.splice(i, 1);
        // this.replacingSystemDataSource.data = this.reStructuredData;
       if (removing.DidNotReplace) {
        removing.DidNotReplace = false;
       } else  {
        removing.DidNotReplace = true;
       }
      }
    }
    if (removing.CompartTypeId === 230) {
      this.IsAChainSystemReplacement = false;
    }
}



compareBackendVaildation(components: ComponentWarningViewModel[]) {
  for ( let i = 0; i < this.reStructuredData.length; i++) {
    if ( (<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).GeneralEqUnitId !== undefined  ) {
      const eqId = (<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).GeneralEqUnitId;
      const findingResult = components.filter( g => g.GeneralEqUnitId === eqId);
      if (findingResult.length > 0) {
          (<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).IsBackendVaildatedStatus = false;
      }       else {
        (<ReplacingComponentsOnSystemViewModel>this.reStructuredData[i]).IsBackendVaildatedStatus = true;
      }
    }

  }
}


pickedActionDate(event) {
  this.actionDate = event;
//  this.getVaildateNewSystem();
}

SMUChanged(event) {
  this.actionAtEquipmentSMU = event;
 // this.getVaildateNewSystem();
}

getVaildateNewSystem() {
  console.log(this.actionDate, this.actionAtEquipmentSMU);
  if (this.actionDate !== undefined && this.actionAtEquipmentSMU !== undefined && this.actionAtEquipmentSMU !== null && this.actionAtEquipmentSMU >= 0) {
    const componentIds = this.getAllComponentsIds();

    this._actionService.getVaildationOfComponentReplacement( componentIds, this.equipmentId, this.actionDate , this.actionAtEquipmentSMU).subscribe(result => {
      // console.log(result);
      this.backEndVaildation = result;
      this.compareBackendVaildation(result.Components);


    });
  }
}


checkTemplateForCompartRemoveFromList(): boolean {
  // const _selectedComponents = this.getSystembyTypeSide(_typeSide).Components;
  // const template = this._systemTemplate.find(m => m.ModelId === this._currentSelection.system.Model.Id && m.CompartTypeId === typeId);
  // const count = _selectedComponents.filter(m => m.Compart.CompartType.Id === typeId).length;
  // if (template && count > template.Min) return true;
  // return false;
  return false;
}

openSnackBar(message: string, action: string) {
  this.snackBar.open(message, action, {
      duration: 5000,
  });
}

// shouldSelectDefault(element: ComponentSetup) {
//   const compartElement = this.getAvailableCompartList(element.Compart.CompartType.Id);


//   if (this._originalSystem !== null && this._originalSystem !== undefined) {
//     const originalCompartOnSystem = this._originalSystem.ComponentsOnSystem.find(c => c.CompartTypeId === element.Compart.CompartType.Id);
//     if (originalCompartOnSystem !== null && originalCompartOnSystem !== undefined && originalCompartOnSystem.EqUnitInfos.length > 0) {
//       const posFind = originalCompartOnSystem.EqUnitInfos.find(e => e.Position === element.Pos);
//       if (posFind !== null && posFind !== undefined) {
//         this.CompartSelected({value: posFind.CompartId}, element);
//         return element.Compart.Id;
//       } else {
//         this.CompartSelected({value: originalCompartOnSystem.EqUnitInfos[0].CompartId}, element);
//         return element.Compart.Id;
//       }
//     }
//   } else if (element.Compart.Id !== 0 && compartElement.length > 0) {
//       this.CompartSelected({ value: element.Compart.Id }, element);
//       return element.Compart.Id;
//   } else {
//       if (compartElement !== undefined && compartElement !== null && compartElement.length === 1) {
//         this.CompartSelected({ value: compartElement[0].Id }, element);
//         return element.Compart.Id;
//     }

//   }
// }



// CompartSelected(event: any, element: ReplacingComponentsOnSystemViewModel) {
//   if (!event.value) return;
//   const selected = this._currentAvailableTypes.find(m => m.Id === event.value);
//   if (!selected) return;
//   element.Compart = selected;

// }

// shoeSizeSelected(event: any, element: ReplacingComponentsOnSystemViewModel) {
//   if (!event.value)
//       return;
//   const selected = this._availableShoeSizes.find(m => m.Id === event.value);
//   if (!selected)
//       return;
//   element.ShoeSize = selected;
// }

// grouserSelected(event: any, element: ReplacingComponentsOnSystemViewModel) {
//   if (!event.value) return;
//   const selected = this._availableGrousers.find(m => m.Id === event.value);
//   if (!selected) return;
//   element.Grouser = selected;
// }


validateComponent( component: ReplacingComponentsOnSystemViewModel): ResultMessage {
  const result: ResultMessage = new ResultMessage();
  result.OperationSucceed = false;


  if (!component.CompartId || component.CompartId === 0) {
      result.LastMessage = this.Translate('Validation failed: Type is not selected!');
      return result;
  }

  // if (!component.Compart.CompartType || component.Compart.CompartType.Id === 0) {
  //     result.LastMessage = this.Translate('Validation failed: Compart Type is not selected!');
  //     return result;
  // }

  if (!component.MakeId || component.MakeId === 0) {
      result.LastMessage = this.Translate('Validation failed: Brand is not selected!');
      return result;
  }

  if (!component.BudgetLife || component.BudgetLife <= 0) {
    result.LastMessage = this.Translate('Validation failed: Budget Life should not be equal or less than 0');
    return result;
  }

  if (component.DidNotReplace === false ) {
    if ( component.IsBackendVaildatedStatus === false) {
        result.LastMessage = this.Translate('Validation failed: There is a future action of this component is the future');
        return result;
    }
  }
  result.OperationSucceed = true;
  result.LastMessage = this.Translate('Validation Passed.');
  return result;
}

isVaild() {
 return this.backEndVaildation !== undefined && this.backEndVaildation.ShouldAllowToPerform;
}


Translate(value: string): string {
  return this._translate.translateToLang(value, this.userLanguage);
}




  private getAvailableComparts(modelId): Observable<Compart[]> {
    return this._setupService.GetAvailableCompartsAll(modelId);
  }

  getAvailableCompartList(typeId: number): Compart[] {
    return this._currentAvailableTypes.filter(m => m.CompartType.Id === typeId);
  }


  getSystemTemplate(modelId: number): Observable<SystemModelTemplate[]> {
   return this._setupService.GetTemplateForModel(modelId);
  }


  showPosition(component: ReplacingComponentsOnSystemViewModel): string {
    if (!component || !component.Position ||  !component.CompartTypeId)
        return '';
    return this._appService.getPositionString(component.Position, component.CompartTypeId);

  }


  isGroup(index, item): boolean {
    return item.isGroupBy;
  }
}


export interface GroupBy {
  isGroupBy: boolean;
  systemType: number;
}
